import { Box, Typography, SxProps, Theme } from "@mui/material";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import SlideNextIcon from "../components/icons/SlidePrevIcon";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import { useIsMobile } from "../hooks";
import { useTranslation } from "react-i18next";
import { images } from "../components/ImageList";
import "../assets/Gallery.css"


const GalleryPageStyle: Record<string, SxProps<Theme>> = {
    slideMobile: {
        marginBottom: "30px",
    },
    slideImageMobile: {
        img: {
            height: "auto",
            width: "100%",
            objectFit: "conver",
        },
    },
    slideCaption: {
        fontSize: "16px",
        textAlign: "center",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
};



const GalleryPage = () => {
    const { isMobile } = useIsMobile();
    const { t, i18n } = useTranslation();

    return (
        <>
            <PageTitle>{t("menu.gallery")}</PageTitle>
            <PageContent fullscreen>
                {/* <div style={{border: "1px solid green"}}> */}
                {!isMobile && (
                    <ImageGallery
                        showPlayButton={false}
                        showThumbnails={true}
                        showFullscreenButton={true}
                        showNav={true}
                        showBullets
                        items={images.map(image => { return { ...image, description: i18n.resolvedLanguage === "en" ? image.descriptionEn : image.descriptionIt } })}
                        renderLeftNav={(onClick, disabled) => (
                            <button
                                type="button"
                                className="image-gallery-icon image-gallery-left-nav"
                                disabled={disabled}
                                onClick={onClick}
                                aria-label="Previous Slide"
                            >
                                <SlideNextIcon style={{ height: "70px", width: "auto" }} />
                            </button>
                        )}
                        renderRightNav={(onClick, disabled) => (
                            <button
                                type="button"
                                className="image-gallery-icon image-gallery-right-nav"
                                disabled={disabled}
                                onClick={onClick}
                                aria-label="Next Slide"
                            >
                                <SlideNextIcon
                                    style={{ height: "70px", width: "auto", rotate: "180deg" }}
                                />
                            </button>
                        )}
                    />
                )}
                {isMobile &&
                    images.map((img) => (
                        <Box sx={GalleryPageStyle.slideMobile}>
                            <Box sx={GalleryPageStyle.slideImageMobile}>
                                <img src={img.original} />
                            </Box>
                            <Typography sx={GalleryPageStyle.slideCaption}>
                                {i18n.resolvedLanguage === "en" ? img.descriptionEn : img.descriptionIt}
                            </Typography>
                        </Box>
                    ))}
                {/* </div> */}
            </PageContent>
        </>
    );
};

export default GalleryPage;
